import styles from './style.module.scss';
import { List, Divider, Row, Col, Spin } from 'antd';
import { Button, PageHeader } from 'components';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useRoom from '../useRoom';
import { useMemo } from 'react';
import { getRoomViewSections } from '../roomViewSections';

const ViewSection = ({ title, fields }) => (
  <List
    header={<div>{title}</div>}
    style={{ marginTop: 24 }}
    dataSource={fields}
    renderItem={(item) => (
      <List.Item>
        <b className={styles.itemName}>{item.text}</b>
        {item.value}
      </List.Item>
    )}
  />
);

const Single = () => {
  const { t } = useTranslation();
  const { singleItem, loading, companies } = useRoom(false);

  const sections = useMemo(
    () => getRoomViewSections(t, singleItem, companies),
    [t, singleItem, companies],
  );

  return (
    <div>
      <PageHeader title={t('UNITA')} />
      <div className={styles.content}>
        <Spin spinning={loading}>
          {sections.map((section) => (
            <ViewSection
              key={section.title}
              title={section.title}
              fields={section.fields}
            />
          ))}
        </Spin>
        <Divider />
        <Row gutter={16}>
          {singleItem?.can_update !== false && (
            <Col>
              <Button>
                <Link to={`/leasing/room/${singleItem?.id}/edit`}>
                  {t('MODIFIICA')}
                </Link>
              </Button>
            </Col>
          )}
          <Col>
            <Button type={'secondary'}>
              <Link to={'/leasing/room'}>{t('TORNA INDIETRO')}</Link>
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Single;
